import Head from 'next/head';
import ExploreGoals from '@cont/ManageGoals/ExploreGoals';
import { fetchOnboardingGoals } from '@api/fetchers/goal';
import { emptyList } from '@constants/empty';
import Layout from '@layout/SimpleLayout/SimpleLayout';

const ExploreGoalsPage = ({ onboardingGoals }) => (
  <>
    <Head>
      <title>Goals | Unacademy</title>
    </Head>
    <ExploreGoals isOnboarding onboardingGoals={onboardingGoals} />
  </>
);

ExploreGoalsPage.pageInfo = {
  name: 'Unacademy Explore',
  isMWebSupported: true,

  layoutOptions: {
    hideSearch: true,
    hideGoalSelector: true,
    showFixedHeader: true,
    showLogin: true
  }
};

export default ExploreGoalsPage;

export const getStaticProps = async () => {
  const onboardingGoals = await fetchOnboardingGoals();

  return {
    props: {
      onboardingGoals: onboardingGoals?.results || emptyList
    },
    revalidate: 60 * 5 // Revalidate the page's build every 5 min
  };
};
ExploreGoalsPage.Layout = Layout;
ExploreGoalsPage.Wrapper = null;
